module.exports = __webpack_public_path__ + "img/Product-JaoKrom.013c3ba1.png";